export class Organization {

  public static readonly CNPJ_OTTIMIZZA = '24367904000118';

  static Type = class {
    static ACCOUNTING = 1;
    static CUSTOMER = 2;
  };

  id: number;
  organizationId: number;

  cnpj: string;
  externalId: boolean;
  type: number;
  active: boolean;

  name: string;
  codigoERP: string;
  avatar: string;
  email: string;

  sistemaContabil?: string;
  classificacao?: string;
  perfil?: string;
  chaveDeAcesso?: string;
  chatBloqueado?: boolean;

}
